<div class="card">
    <div class="card-body">
        <ul class="list-group list-group-flush fee-list">
            @for (fee of fees; track fee) {
            <li class="list-group-item">
                <p class="due {{dueToClass(fee.due)}}" title="{{daysPastDue(fee.due)}}d">
                    @if (dueToClass(fee.due) !== 'past') {
                    <span>{{fee.due | date:'M/d'}}</span>
                    }
                    @if (dueToClass(fee.due) === 'past') {
                    <span>{{fee.due | date:'M/d'}}</span>
                    }
                    @if (daysPastDue(fee.due) > 0) {
                    <span class="days">{{daysPastDue(fee.due)}}d</span>
                    }
                </p>
                <div class="text-left">
                    <p class="title">{{fee.category | lowercase}} for <abbr title="Loan payment &#35;{{fee.number}} was due on {{fee.scheduledDue | date:'fullDate'}}">payment &#35;{{fee.number}}</abbr></p>
                    @if (fee.waived !== null) {
                    <p class="subtitle text-wrap">waived by {{fee.waiver}} on {{fee.waived | date:'MMM d, yy'}} {{fee.reason || ''}}</p>
                    }
                </div>
                @if ((waiving) && (fee.id == feeToWaiveId)) {
                <div class="form-group">
                    <div class="input-group input-group-sm">
                        <input id="{{fee.id}}-waive-reason" class="form-control form-control-sm" type="text" placeholder="reason" autocomplete="off" autofocus="true" />
                        <div class="input-group-append"><button class="btn btn-sm btn-danger" (click)="waive(fee.id)">waive</button></div>
                    </div>
                </div>
                }
                @if (!waiving) {
                <div class="currency">
                    <p class="title">{{(fee.amount - fee.paid) | currency}}</p>
                    @if ((fee.status == 'Partially Paid') && (fee.paid > 0)) {
                    <p class="subtitle">partially paid {{fee.paid | currency}}</p>
                    }
                </div>
                }
                <div class="actions">
                    @if (fee.waived == null) {
                    <span class="material-icons text-danger" title="waive payment fee" (click)="initWaive(fee.id)">waving_hand</span>
                    }
                    @if (fee.waived !== null) {
                    <span class="material-icons text-secondary" title="restore payment fee" (click)="restore(fee.id)">restore</span>
                    }
                </div>
            </li>
            }
        </ul>
    </div>
</div>